(function() {
  'use strict';

  angular
    .module('blocks.errorHandler')
    .factory('errorHandler', errorHandler);

  errorHandler.$inject = [
    'ERROR_HANDLER_SENDS_EMAIL',
    '$anchorScroll', '$document', '$http',
    '$state', '$timeout',
    'currentSiteService', 'locationHelper',
    'loggedInUserService', 'logger', 'i18nService'];

  function errorHandler(
    ERROR_HANDLER_SENDS_EMAIL,
    $anchorScroll, $document, $http,
    $state, $timeout,
    currentSiteService, locationHelper,
    loggedInUserService, logger, i18nService) {

    var all = [];

    return {
      catcher,
      getHandler,
      clearHandlerForController,
      prepareHandlerForController,
      prepareHandlerForObject: prepareHandlerForController,
    };

    ////

    function catcher(handlerName, controller) {
      return function requestFailed(error) {
        prepareHandlerForController(handlerName, controller);
        controller[handlerName].addError(error);
        return error;
      };
    }

    function clearHandlerForController(handlerName, controller) {
      if (controller && controller[handlerName]) {
        controller[handlerName].clearErrors();
      }
    }

    function prepareHandlerForController(handlerName, controller, scrollElementId) {
      controller[handlerName] = controller[handlerName] || getHandler(controller, scrollElementId);
    }

    function getHandler(controller, scrollElementId = 'error-handler') {
      const isSuperUser = !!(loggedInUserService.loggedInUser && loggedInUserService.loggedInUser.superUser);

      var handler = {
        addError,
        clearErrors,
        controller: isSuperUser ? safeAngularCopy(controller) : undefined,
        emailSent: false,
        status: null,
        errors: [],
        detailsVisible: false,
        isSuperUser,
        latestErrorMessage: '',
        sendingEmail: false,
        toggleDetailsVisibility,
      };

      all.push(handler);

      return handler;

      ////

      function addError(error) {
        if (!isSuperUser) {
          handler.errors.push(i18nService.get('errorHandler.ohNo'));
        } else {
          if (handler.controller) {
            error.controller = getPreparedController();
          }

          handler.errors.push(JSON.stringify(error, null, 2));
        }

        if (handler.errors.length === 1) {
          handler.status = error.data && error.data.status;
          if (!errorCausedByBadConnection()) {
            logger.error(error);
          }
        }

        $timeout(function () {
          if ($document.scrollToElementAnimated) {
            var element = $('#' + scrollElementId);
            if (element.length) {
              locationHelper.scrollTo(element, {
                scrollOffset: 'thirdway',
                scrollOnlyIfOutOfSight: true,
              });
            }
          } else {
            $anchorScroll(scrollElementId);
          }
        }, 0);

        function errorCausedByBadConnection() {
          return error.data === null || (error.data && (error.data.data === null || (error.data.data && error.data.data.data === null)));
        }

        function getPreparedController() {
          return removeAngularInternalVars(angular.copy(handler.controller));

          function removeAngularInternalVars(obj) {
            angular.forEach(obj, function (value, key) {
              if (typeof key === 'string' && key.length > 1 && (key.substring(0, 2) === '$$' || key === '_ancestors')) {
                delete obj[key];
              } else if (typeof value === 'object') {
                removeAngularInternalVars(obj[key]);
              }
            });
            return obj;
          }
        }
      }

      function clearErrors() {
        handler.errors = [];
        handler.detailsVisible = false;
        handler.latestErrorMessage = '';
      }

      function safeAngularCopy(object, path = 'root') {
        const objectCopy = {};
        angular.forEach(object, function (property, name) {
          if (!angular.isObject(property) || angular.isArray(property)) {
            try {
              objectCopy[name] = angular.copy(property);
            } catch (err) {
              console.error('Cannot create safeAngularCopy of ' + path + '.' + name + ', err: ' + err); // eslint-disable-line no-console
            }
          } else if (!objectIsAngularScopeOrWindow(property)) {
            objectCopy[name] = safeAngularCopy(property, path + '.' + name);
          }
        });
        return objectCopy;

        function objectIsAngularScopeOrWindow(obj) {
          return isAngularScope(obj) || isWindow(obj);

          function isAngularScope(obj) {
            let isScope = false;
            angular.forEach(obj, function (property, name) {
              if (name.length > 2 && name.substr(0, 2) === '$$') {
                isScope = true;
              }
            });
            return isScope;
          }

          function isWindow(obj) {
            return (obj && obj.document && obj.location && obj.alert && obj.setInterval && true) || false;
          }
        }
      }

      function toggleDetailsVisibility() {
        handler.detailsVisible = !handler.detailsVisible;
      }
    }

  }

})();
